import BaseballPhase from "app/components/BaseballPhase/BaseballPhase";
import { GolfPhase } from "app/components/GolfPhase/GolfPhase";
import { IconBack } from "app/components/Icon/Icon";
import { geniusScoreboardSports, SportsNameType } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import cx from "classnames";
import words from "lodash/words";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import DangerZone from "../../../../../../components/DangerZone/DangerZone";
import {
  IconClock,
  IconFavorite,
} from "../../../../../../components/Icon/Icon";
import {
  MomentDate,
  MomentTime,
} from "../../../../../../components/Moment/Moment";
import { EventHelper } from "../../../../../../helpers/eventHelper";
import type {
  EventIncidentType,
  EventType,
} from "../../../../../../types/eventType";
import type { NavigationMetaType } from "../../../../../../types/navigationType";
import { REGEX_VS } from "../../../../../../utils/const";
import { toUrlFriendlyName } from "../../../CompetitionScreenWrapper/nameHelper";
import "./EventDetailScreenHeader.scss";
type Props = {
  history: any;
  competition: string;
  navigationNodeIds: number[];
  teams: string;
  score?: string;
  isRunning: boolean;
  allowLiveBetting: boolean;
  dateTime: string;
  eventIncidents: EventIncidentType[];
  event: EventType;
  addFavouriteToList: (...args: Array<any>) => any;
  removeFromFavouritesList: (...args: Array<any>) => any;
  setCompetitionWithFavouritesList: (...args: Array<any>) => any;
  navigationTree: NavigationMetaType;
  favouritesOnly: boolean;
  widgetExpanded: boolean;
  toggleWidget: Function;
  disableFilter: Function;
  disableTodayEarlyFilter: Function;
  updateBreadCrumb: Function;
  setFavouritesOnly: Function;
  darkMode: boolean;
  fetchEventData: Function;
  userTimezone: Record<string, any>;
  previousRoute: string;
};
type State = {
  isFavourite: boolean;
};

class EventDetailScreenHeader extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isFavourite: this.props.event.favourite ? true : false,
    };
  }

  renderLeftTeam = () => {
    if (this.props.teams) {
      let name: Element | any = this.props.teams.split(REGEX_VS)[0];
      name = name != null && name.trim();
      return (
        <div
          className={cx(
            "event-detail-header__details__team",
            "event-detail-header__details__team--text-right"
          )}
        >
          {name}
        </div>
      );
    }
  };
  renderRightTeam = () => {
    if (this.props.teams) {
      let name = this.props.teams.split(REGEX_VS)[1];
      name = name != null && name.trim();
      return <div className="event-detail-header__details__team">{name}</div>;
    }
  };
  renderState = (isInExtraTime: boolean) => {
    if (this.props.isRunning && this.props.score) {
      return (
        <div className="event-detail-header__details__team__state">
          {this.props.score}
          {isInExtraTime ? " ET" : ""}
          {this.renderGoingLive()}
        </div>
      );
    }

    if (this.props.teams) {
      return (
        <div className="event-detail-header__details__team__state">
          {words(this.props.teams, REGEX_VS)}
          {this.renderGoingLive()}
        </div>
      );
    }
  };
  renderGoingLive = () => {
    return (
      this.props.allowLiveBetting && (
        <IconClock className="event-detail-header__details__clock-icon" />
      )
    );
  };

  onClickFavourite = () => {
    if (!this.props.event.favourite) {
      this.props.addFavouriteToList(this.props.event.id, resp => {
        this.props.event.favourite = resp.id;
        this.forceUpdate();

        if (this.props.favouritesOnly) {
          this.props.setCompetitionWithFavouritesList();
        }
      });
    } else {
      this.props.removeFromFavouritesList(this.props.event.id, resp => {
        delete this.props.event.favourite;
        this.forceUpdate();

        if (this.props.favouritesOnly) {
          this.props.setCompetitionWithFavouritesList();
        }
      });
    }
  };

  toggleWidgets = () => {
    this.props.toggleWidget(!this.props.widgetExpanded);
  };

  componentDidMount = () => {
    // always set default widget to collapsed,
    // unless it is cricket, as betradar cricket doesnt have a compact version
    this.props.event.sportType === SportsNameType.CRICKET
      ? this.props.toggleWidget(true)
      : this.props.toggleWidget(false);
  };

  render() {
    const {
      isRunning,
      dateTime,
      eventIncidents,
      event,
      widgetExpanded,
      competition: competitionName,
    } = this.props;

    const isInExtraTime =
      EventHelper.isEventIncidentPhaseExtraTime(eventIncidents);
    let aggregatedScore = "";
    const reactToolTip = (
      <ReactTooltip place="bottom" type="dark" effect="solid" />
    );
    const isEventLive = EventHelper.isEventLive(event);

    if (isInExtraTime) {
      aggregatedScore = EventHelper.getScores(
        eventIncidents[0]["scoreDetails"],
        event.showHomePlayerAsFirst
      );
    }

    const isWidgetAvailable = event?.widgets?.widgetProvider ? true : false;
    const isWidgetExpanable = !(
      event.sportType === SportsNameType.CRICKET ||
      geniusScoreboardSports.includes(event?.sportType)
    );

    const backUrl = this.props.previousRoute || "/events";

    return (
      <div
        className={`event-detail-header  ${
          isPublicView() ? "public-view-mobile" : ""
        }`}
      >
        <div
          className={`event-detail-header__navigation ${
            isPublicView() ? "public-view-mobile" : ""
          }`}
        >
          <Link to={backUrl}>
            <IconBack />
          </Link>

          <Link
            className="event-detail-header__competition"
            to={{
              pathname: `/competition/${toUrlFriendlyName(competitionName)}`,
              search: "?filter=popular",
            }}
          >
            {competitionName}
          </Link>
          <button
            className={`event-detail-header__favorite-button ${
              isPublicView() ? "disabled" : ""
            }`}
            onClick={this.onClickFavourite}
            disabled={isPublicView()}
          >
            <IconFavorite
              className={cx("event-detail-header__favorite-button__icon", {
                "event-detail-header__favorite-button__icon--active":
                  event.favourite,
              })}
            />
          </button>
        </div>
        {!isWidgetAvailable && (
          <>
            <div
              className="event-detail-header__details"
              data-tip={`${aggregatedScore || ""} (FT)`}
            >
              {event.sportType === SportsNameType.GOLF ? (
                <span className="event-detail-header__details__name">
                  {event.name}
                  <div className="event-detail-header__golf-live">
                    {isEventLive ? <GolfPhase eventData={event} /> : ""}
                  </div>
                </span>
              ) : (
                <React.Fragment>
                  {isInExtraTime ? reactToolTip : ""}
                  {this.renderLeftTeam()}
                  {this.renderState(isInExtraTime)}
                  {this.renderRightTeam()}
                </React.Fragment>
              )}
            </div>
            <div className="event-detail-header__bottom">
              {!isRunning && (
                <div className="event-detail-header__time">
                  <MomentDate value={dateTime} />
                  ,&nbsp;
                  <MomentTime value={dateTime} />
                </div>
              )}
              {event.sportType === SportsNameType.BASEBALL && (
                <BaseballPhase eventData={event} />
              )}
              {eventIncidents && event.sportType === SportsNameType.SOCCER && (
                <DangerZone
                  className="event-detail-header__danger-zone"
                  eventIncident={eventIncidents[0]}
                />
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  navigationTree: state.navigationModel.navigationTree,
  favouritesOnly: state.competitionListModel.favouritesOnly,
  widgetExpanded: state.singleEventModel.widgetExpanded,
  darkMode: state.sessionModel.darkMode,
  userTimezone: state.userModel.timezone,
  previousRoute: state.navigationModel.previousRoute,
});

function mapDispatchToProps(dispatch) {
  return {
    setCompetitionWithFavouritesList: callback => {
      dispatch.competitionListModel.setCompetitionWithFavouritesList(callback);
    },
    toggleWidget: (widgetExpanded: boolean) => {
      dispatch.singleEventModel.toggleWidget(widgetExpanded);
    },
    addFavouriteToList: (eventId, callback) =>
      dispatch.favouritesListModel.addFavouriteToList({
        eventId,
        callback,
      }),
    removeFromFavouritesList: (eventId, callback) =>
      dispatch.favouritesListModel.removeFromFavouriteToList({
        eventId,
        callback,
      }),
    disableFilter: disable =>
      dispatch.competitionListModel.disableFilter(disable),
    disableTodayEarlyFilter: disable =>
      dispatch.competitionListModel.disableTodayEarlyFilter(disable),
    updateBreadCrumb: updateBreabcrumbState =>
      dispatch.navigationModel.updateBreadCrumb(updateBreabcrumbState),
    setFavouritesOnly: updateBreabcrumbState =>
      dispatch.competitionListModel.setFavouritesOnly(updateBreabcrumbState),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventDetailScreenHeader) as any;
